import { compose } from 'redux';
import { connect } from 'react-redux';

import AuthenticationPage from './component';
import { authenticationRequest } from '@/actions';

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated,
  redirect_url: state.user.redirect_url,
});
const mapDispatchToProps = ({
  authenticationRequest,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(AuthenticationPage);
